// extracted by mini-css-extract-plugin
export var label = "_ct-2";
export var slideContainer = "_ct-0";
export var slider = "_ct-1";